const o = "qeq", I = "ghItlh", E = "jIghoS ({{quality}})", n = "qa' yIbuS", t = "yIngwIj", c = "yIqIHbe'mey QapDaq vIghro'", A = "Hol QapDaq vIghro'", s = "yIngwIj lo'ta' nIbuS", S = "yIngwIj lo'ta' nIbuS vIghro'", _ = "QapDaq vIghro'", T = "Dolth {{language}}", N = "lo'ta'", O = "yIngwIj Hol: {{language}}", a = "chaw'", e = "qechmey", h = "taH", C = "yIjDu' qachDaq jIqeq", P = "tInwIj qachDaq HablI' veS", U = "SoQmey 'ugh", q = "nIvbogh jIpIj", D = "jIqeqpuma' jIpIj", u = "yIjDu' qachDaq Qab", L = "tInwIj qachDaq Qab", l = "lujmuS mewbeH", g = "jItuvHa'wI' (1-10%, 2-20%, ghob)", R = "yItlhutlhmeH jIjlo'", j = "pu'chuqHom nIHneHmey", y = "Hol", H = "chay' SoQ", G = "ghu' vIghro'", M = "ghll", m = "batlh", v = "qel yIngwIj Hol", b = "Hoch", w = "QI'ta' qorDaq", Q = "Qo'noS", r = "yItlh", p = "yIjDu' veS", K = "yIjDu' veS: {{speed}}x", Y = "yIngwIj Hol tInmoH", B = "HIQ", F = "qel vIghro'", V = "yIjDu' qachDaq reset", W = "SoQmey 'ugh", d = "Hovmey yIbuS: {{seconds}}", x = "yIbuS: {{seconds}}", J = "nIvbogh", X = "pu'chuqHom", Z = "mIw", f = "vIqID vIghro'", i = "yIngwIj lo'ta' nIbuS", k = "mIw tImlaw'", z = "qeq je muSmeH nIvbogh", $ = "QoQ SoQ", oo = "qur", Io = "tInwIj: {{volume}}%", Eo = {
  ACTION: o,
  ANNOTATIONS: I,
  AUTO: E,
  BACK: n,
  CAPTIONS: t,
  CAPTIONS_FONT_SIZE_MENU: c,
  CAPTIONS_LANGUAGE_MENU: A,
  CAPTIONS_MANAGE: s,
  CAPTIONS_MANAGE_MENU: S,
  CAPTIONS_MENU: _,
  CAPTION_DELETE: T,
  CAPTION_FONT_SIZE: N,
  CAPTION_LANGUAGE: O,
  CLOSE: a,
  COMMENTS: e,
  CONTINUE: h,
  DECREASE_PLAYBACK_SPEED: C,
  DECREASE_VOLUME: P,
  DOWN_ARROW: U,
  ENTER_FULLSCREEN: q,
  EXIT_FULLSCREEN: D,
  INCREASE_PLAYBACK_SPEED: u,
  INCREASE_VOLUME: L,
  INVERT_COLORS: l,
  JUMP_TO_PERCENTAGE: g,
  JUMP_TO_START: R,
  KEYBOARD_SHORTCUTS: j,
  LANGUAGE: y,
  LEFT_ARROW: H,
  MAIN_MENU: G,
  MUTE: M,
  MUTED: m,
  NEXT_CAPTION_LANGUAGE: v,
  OFF: b,
  ON_TOP: w,
  PAUSE: Q,
  PLAY: r,
  PLAYBACK_SPEED: p,
  PLAYBACK_SPEED_MESSAGE: K,
  PREVIOUS_CAPTION_LANGUAGE: Y,
  QUALITY: B,
  QUALITY_MENU: F,
  RESET_PLAYBACK_SPEED: V,
  RIGHT_ARROW: W,
  SEEK_BACKWARD: d,
  SEEK_FORWARD: x,
  SETTINGS: J,
  SHORTCUT: X,
  SPACE: Z,
  SPEED_MENU: f,
  TOGGLE_CAPTIONS: i,
  TOGGLE_MUTED: k,
  TOGGLE_PLAY_PAUSE: z,
  UP_ARROW: $,
  VOLUME: oo,
  VOLUME_VALUE: Io
};
export {
  o as ACTION,
  I as ANNOTATIONS,
  E as AUTO,
  n as BACK,
  t as CAPTIONS,
  c as CAPTIONS_FONT_SIZE_MENU,
  A as CAPTIONS_LANGUAGE_MENU,
  s as CAPTIONS_MANAGE,
  S as CAPTIONS_MANAGE_MENU,
  _ as CAPTIONS_MENU,
  T as CAPTION_DELETE,
  N as CAPTION_FONT_SIZE,
  O as CAPTION_LANGUAGE,
  a as CLOSE,
  e as COMMENTS,
  h as CONTINUE,
  C as DECREASE_PLAYBACK_SPEED,
  P as DECREASE_VOLUME,
  U as DOWN_ARROW,
  q as ENTER_FULLSCREEN,
  D as EXIT_FULLSCREEN,
  u as INCREASE_PLAYBACK_SPEED,
  L as INCREASE_VOLUME,
  l as INVERT_COLORS,
  g as JUMP_TO_PERCENTAGE,
  R as JUMP_TO_START,
  j as KEYBOARD_SHORTCUTS,
  y as LANGUAGE,
  H as LEFT_ARROW,
  G as MAIN_MENU,
  M as MUTE,
  m as MUTED,
  v as NEXT_CAPTION_LANGUAGE,
  b as OFF,
  w as ON_TOP,
  Q as PAUSE,
  r as PLAY,
  p as PLAYBACK_SPEED,
  K as PLAYBACK_SPEED_MESSAGE,
  Y as PREVIOUS_CAPTION_LANGUAGE,
  B as QUALITY,
  F as QUALITY_MENU,
  V as RESET_PLAYBACK_SPEED,
  W as RIGHT_ARROW,
  d as SEEK_BACKWARD,
  x as SEEK_FORWARD,
  J as SETTINGS,
  X as SHORTCUT,
  Z as SPACE,
  f as SPEED_MENU,
  i as TOGGLE_CAPTIONS,
  k as TOGGLE_MUTED,
  z as TOGGLE_PLAY_PAUSE,
  $ as UP_ARROW,
  oo as VOLUME,
  Io as VOLUME_VALUE,
  Eo as default
};
